import { useState } from 'react'

import { ruleCountLabel } from './blockedDomainsUtils'
import NotetakerBlockedDomainsModal from './NotetakerBlockedDomainsModal'

import parentStyles from '@/pages/app/Settings/styles.module.scss'

import InfoIcon from '@/assets/icons/info.svg?react'
import Button from '@/components/Button'
import Tooltip from '@/components/Tooltip'
import { EnterpriseSettings, SettingType } from '@/types'

const TOOLTIP =
  "Configure email domains, which, when present on a linked calendar invite, block members from using Notetaker for that meeting. E.g., if you'd like to block use of Notetaker for calendar meetings where your external law firms domain is an attendee, add *@lawfirm.com."

interface NotetakerBlockedDomainsCardProps {
  settings: EnterpriseSettings
  isAdmin: boolean
  authoringEnabled?: boolean
}

const NotetakerBlockedDomainsCard = ({
  settings,
  isAdmin,
  authoringEnabled = true,
}: NotetakerBlockedDomainsCardProps) => {
  const [modalOpen, setModalOpen] = useState(false)

  const rules = settings[SettingType.notetakerBlockedDomains] ?? []
  const label = rules.length > 0 ? `Blocked domains (${ruleCountLabel(rules.length)})` : 'Blocked domains'

  return (
    <>
      <div className={parentStyles.settingsItem} data-testid="notetaker-blocked-domains-setting">
        <div className={parentStyles.toggleLabel}>
          {label}
          <Tooltip text={TOOLTIP} placement="top" hideArrow>
            <InfoIcon className={parentStyles.infoIcon} />
          </Tooltip>
        </div>
        <Button
          title={rules.length > 0 ? 'Configure' : 'Add domains'}
          onClick={() => setModalOpen(true)}
          type="dark"
          className={parentStyles.controlButton}
          isDisabled={!isAdmin && rules.length === 0}
        />
      </div>

      <NotetakerBlockedDomainsModal
        isOpen={modalOpen}
        close={() => setModalOpen(false)}
        currentRules={rules}
        isAdmin={isAdmin}
        authoringEnabled={authoringEnabled}
      />
    </>
  )
}

export default NotetakerBlockedDomainsCard
